import { useOptionalSession } from '../../../app/providers/session-context';
import React, { useEffect, useRef, useState } from 'react';
import { Send } from '../../assets/AppIcons';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { getAuthorInitials, resolveCommentAuthor } from './commentThread.helpers';

const SendIcon = Send || (() => null);

export default function CommentComposer({
  currentUser,
  staff = [],
  placeholder = 'Scrivi un commento...',
  submitLabel = 'Invia commento',
  disabled = false,
  isSubmitting = false,
  onSubmit,
  initialValue = '',
  compact = false,
  autoFocus = false,
}) {
  const session = useOptionalSession();
  currentUser = currentUser || session?.currentUser;
  const inputRef = useRef(null);
  useEffect(() => {
    if (!autoFocus) return undefined;
    const timer = setTimeout(() => {
      inputRef.current?.focus();
      inputRef.current?.scrollIntoView?.({ block: 'center' });
    }, 0);
    return () => clearTimeout(timer);
  }, [autoFocus]);
  const [value, setValue] = useState(initialValue);
  const currentAuthor = resolveCommentAuthor(
    {
      authorFullName: currentUser?.fullName || currentUser?.name || currentUser?.displayName,
      authorEmail: currentUser?.email,
      authorUserId: currentUser?.id,
      linkedWorkspaceUserId: currentUser?.linkedWorkspaceUserId,
    },
    { staff, currentUser }
  );
  const trimmedValue = value.trim();

  async function submit(event) {
    event?.preventDefault();
    if (!trimmedValue || disabled || isSubmitting) return;

    const result = await onSubmit?.({
      body: trimmedValue,
      text: trimmedValue,
      content: trimmedValue,
    });
    if (result?.ok === false) return;
    setValue('');
  }

  return (
    <div className={`comment-composer${compact ? ' comment-composer--compact' : ''}`}>
      <div className="comment-thread__avatar" aria-hidden="true">
        {getAuthorInitials(currentAuthor)}
      </div>
      <div className="comment-composer__body">
        <strong className="comment-composer__author">{currentAuthor}</strong>
        <Textarea
          ref={inputRef}
          aria-label={placeholder}
          value={value}
          rows={compact ? 2 : 3}
          placeholder={placeholder}
          disabled={disabled || isSubmitting}
          onChange={(event) => setValue(event.target.value)}
        />
        <div className="comment-composer__actions">
          <Button type="button" onClick={submit} disabled={!trimmedValue || disabled || isSubmitting}>
            <SendIcon size={16} />
            <span>{isSubmitting ? 'Invio...' : submitLabel}</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
